export default __webpack_public_path__ + "static/img-art-pandas-profiling-11-22d813877e87f4800555ce6133f139ad.png";